import script from "./EditNormalEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditNormalEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditNormalEvent.vue?vue&type=style&index=0&id=0232bb03&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0232bb03"]])

export default __exports__